var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"landing-promo-carousel mx-auto"},[_c('div',{staticClass:"content-container"},[_c('PromoCarousel',{attrs:{"slug":"landing-page-promo","isSlideshow":true,"autoPlayCarousel":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }